import React from 'react';
import './leftPanel.scss';
import { connect } from 'react-redux';
import { apiPost, getHostApi, isObjectPathDefined, hasPermission } from '../../store/apiWrapper';
import { writeErr, writeInfo } from '../common/logger';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Rozbalit from '../../img/icons/BBiconsRozbalitVse';
import PanelItem from "./panelItem";
import classnames from 'classnames';
import ManuLogoLink from './menuLogoLink';
import { links } from './links';
import { isNullOrUndefined } from '../../store/storeFunctions';

class LeftPanel extends React.Component {
    static defaultProps = {
        disableUpdate: false,
        forceFixed: null
    };

    state = {
        timer: null,
        scrollTop: 0,
        fixed: false,
        hide: false
    };

    render() {
        return (<>
            {!this.state.hide &&
            <div className={classnames("left-panel", {"tinted": this.props.tinted})} >
                <div className="logo-wrapper">
                    <ManuLogoLink tinted={this.props.tinted} fixed={this.state.fixed} />
                    <div className="lock">
                        <Rozbalit className='svg-standard-fill' onClick={() => this.fixLeftPanel()} />
                    </div>
                </div>
                {!this.props.user.authentication.limitedUser &&
                    <PerfectScrollbar onScroll={this.onPanelScroll} options={{ maxScrollbarLength: 150 }}>
                        <div className='scrollbar-content' ref={el => this.panelHolder = el}>
                            <div className="menu-wrapper">
                                <ul className="menu-nav">
                                {this.props.user.authentication.profile.agentLanguage === 'sk-SK' &&
                                    links.sort((a, b) => a.orderSk - b.orderSk).map((p, i) =>
                                        <PanelItem key={i} p={p} isSk isFixed={this.state.fixed} scrollTop={this.state.scrollTop}
                                            panelHolder={this.panelHolder} />)
                                }
                                {this.props.user.authentication.profile.agentLanguage === 'cs-CZ' &&
                                    links.sort((a, b) => a.orderCz - b.orderCz).map((p, i) =>
                                        <PanelItem key={i} p={p} isCz isFixed={this.state.fixed} scrollTop={this.state.scrollTop}
                                            panelHolder={this.panelHolder} />)
                                }
                                </ul>
                            </div>
                        </div>
                    </PerfectScrollbar>
                }
            </div>
            }
            </>
        );
    }

    componentDidMount() {
        const fixed = this.props.forceFixed === undefined || this.props.forceFixed === null ? this.getFixedValue() : this.props.forceFixed
        const hide = this.HideLeftPanel();
        document.body.classList.remove('lp-hide')
        if(fixed) {
            document.body.classList.remove('lp-minimized')
            hide ? document.body.classList.add('lp-hide') : document.body.classList.add('lp-fixed')
        }
        else {
            document.body.classList.remove('lp-fixed')
            hide ? document.body.classList.add('lp-hide') : document.body.classList.add('lp-minimized');
        }
        this.setState({fixed, hide});
    }

    getFixedValue = () =>{
        return this.props.user.authentication.profile.displaySettings.fixedLeftPanel === '1';
    }

    fixLeftPanel = () => {
        const fixed = !this.state.fixed;
        this.setState({fixed});
        if(fixed) {
            document.body.classList.remove('lp-minimized')
            document.body.classList.add('lp-fixed')
        } else {
            document.body.classList.remove('lp-fixed')
            document.body.classList.add('lp-minimized')
        }
        if (!this.props.disableUpdate && isObjectPathDefined(this.props, 'user.authentication.profile.displaySettings') &&
        (this.props.user.authentication.profile.displaySettings.fixedLeftPanel === '1') !== fixed) {
            this.props.updateFixedLeftPanel(fixed ? '1' : '0');
        }
    }

    onPanelScroll = (evnt) => {
        this.setState({scrollTop:((evnt.target || {}).scrollTop || 0)});
    }

    HideLeftPanel = () => {
        var activePanels = links.filter(e => e.canShow() === true);
        if (hasPermission(null, 'MainRepi') && ( isNullOrUndefined(activePanels) || activePanels.length === 0))
                return true;
        else 
            return false;
    }
}

// linked to layout only to catch location change and re-render
export default connect(
    state => { return { layout: state.layout, user: state.userContext } },
    dispatch => bindActionCreators(userContextActions, dispatch)
)(LeftPanel);